import * as React from 'react'
import Switch from 'react-switch'
import { I18n } from 'react-redux-i18n'
import { Tooltip, UncontrolledTooltip } from 'reactstrap'

import PhoneViewer from 'components/PhoneViewer'
import { Button } from 'components/Form'
import ModalDelete from 'components/ModalDelete'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { validateShorcutsAV } from 'utils/helpers'
import { ALLOWED_DOMAINS } from 'constants/index'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { LangSelector } from 'components/common'
import flagEnvDisplay from 'constants/flagEnvDisplay'
const _ = require('lodash')

const ConsoleQuestion = (props) => {
  const [isChecked, setIsChecked] = React.useState(props.question.isActive)
  const [questionList, setQuestionList] = React.useState([])
  const [answer, setAnswer] = React.useState({})
  const shortCut = props.question.keyboardShortcut
  const [editorIsVisible, setEditorIsVisible] = React.useState(false)
  const [textPreview, setTextPreview] = React.useState({})
  const [onPreview, setOnPreview] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const [reviewStatusTooltipOpen, setReviewStatusTooltipOpen] = React.useState(false)
  const toggle = () => setReviewStatusTooltipOpen(!reviewStatusTooltipOpen)
  const totalQuestions = 5
  const initialQuestions = 3
  const [counterQuestions, setCounterQuestions] = React.useState([{ category: props.category, counter: initialQuestions }])
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [currentChannelPreview, setCurrentChannelPreview] = React.useState(undefined)
  const [isOpenModalDelete, setIsOpenModalDelete] = React.useState(false)
  const [funcLetterInput, setFuncLetterInput] = React.useState(shortCut ? shortCut : '')
  const [questionListData, setQuestionListData] = React.useState([])
  const [questionListIndexEdit, setQuestionListIndexEdit] = React.useState([])
  const [answerList, setAnswerList] = React.useState({})
  const [answerLang, setAnswerLang] = React.useState('')

  const openEditQuestion = async () => {
    const data = await props.openEditQuestion(props.question._id)
    const questions = data.reformulationList.map(question => question['es'])
    const answerList = data.answerList[0]
    const answerLang = Object.keys(answerList)[0]
    setAnswerList(answerList)
    setAnswer({ ...answerList[answerLang] })
    setAnswerLang(answerLang)
    setEditorIsVisible(true)
    setCounterQuestions([{ category: props.category, counter: questions.length > initialQuestions ? questions.length : initialQuestions }])
    setQuestionList(questions)
    setQuestionListData(questions)
    setQuestionListIndexEdit(questions)
  }

  const changeStatus = async () => {
    const isActive = !isChecked
    setIsChecked(isActive)

    try {
      await props.changeQuestionStatus(props.question._id, isActive)
    } catch(error) {
      setIsChecked(!isActive)
    }
  }

  const errorChecking = ({ newQuestions }) => {
    if (newQuestions.length < 2) {
      setErrorMessage('Por favor, ingresa por lo menos dos formulaciones.')
      return false
    }

    if (!textPreview.content) {
      setErrorMessage('Por favor, ingresa una respuesta.')
      return false
    }

    if (!answerLang) {
      setErrorMessage('Por favor, selecciona el idioma de la respuesta.')
      return false
    }

    return true
  }

  const disableSaveIntent = () => {
    const firstTextChanged = questionListData[0] !== questionList[0]
    const secondTextChanged = questionListData[1] !== questionList[1]
    const thirdTextChanged = questionListData[2] !== questionList[2]
    const fourthTextChanged = questionListData[3] ? questionListData[3] !== questionList[3] : null
    const fifthTextChanged = questionListData[4] ? questionListData[4] !== questionList[4] : null
    const answerChanged = textPreview?.content !== answer?.content
     || textPreview?.attachments?.length !== answer?.attachments?.length
     || textPreview?.buttons?.length !== answer?.buttons?.length
     || textPreview?.removeEmojisAndAccents !== answer?.removeEmojisAndAccents
    const shortcutChanged = shortCut !== funcLetterInput
    const isChanged = firstTextChanged
      || secondTextChanged
      || thirdTextChanged
      || fourthTextChanged
      || fifthTextChanged
      || answerChanged
      || shortcutChanged

    return !isChanged
  }

  const saveIntent = async () => {
    const newQuestions = [questionListData[0], questionListData[1], questionListData[2]]
    questionListData[3] && newQuestions.push(questionListData[3])
    questionListData[4] && newQuestions.push(questionListData[4])

    if (!errorChecking({ newQuestions })) return

    setIsSubmitting(true)
    await props.updateIntent(props.question._id, newQuestions, answerLang, textPreview, funcLetterInput.replace(/ +/g, ""), true)
    props.inputContentChanged(true, props.question._id)
    setIsSubmitting(false)
    setAnswer({})
  }

  const closeQuestionEdit = () => {
    props.inputContentChanged(false, props.question._id)
  }

  const getIcon = (status) => {
    switch (status) {
      case 'add_formulations':
        return 'icon-warning-yellow.svg'
      case 'rewrite_formulations':
        return 'icon-warning.svg'
      case 'add_rewrite_formulations':
        return 'icon-warning-red.svg'
      case 'reviewed':
        return 'icon-warning-gray-white.svg'
      default:
        return 'icon-warning-gray-white.svg'
    }
  }

  const question = (counter, index, disableEdit) => {
    return (
      <div key={counter} className='question-input-container'>
        <p className='question-input-container__title'>
          {I18n.t(`dashboard_${counter}-formulation`)}
        </p>
        <input
          id={`${index}Formulation`}
          className='question-input'
          defaultValue={''}
          value={questionListData[index] ? questionListData[index] : ''}
          disabled={ALLOWED_DOMAINS.type === 'TA' ? disableEdit : false}
          onChange={({ target }) => {
            const _questionList = _.clone(questionListData)
            _questionList[index] = target.value
            setQuestionListData(_questionList)}
          }
          placeholder={I18n.t('faq_console_question_add_input_question_placeholder')}
        />
      </div>
    )
  }

  const showQuestion = (counter) => {
    let q = []
    for (let index = 0; index < counter; index++) {
      index === 0 && q.push(question('first', index, !!questionListIndexEdit[index]))
      index === 1 && q.push(question('second', index, !!questionListIndexEdit[index]))
      index === 2 && q.push(question('third', index, !!questionListIndexEdit[index]))
      index === 3 && q.push(question('fourth', index, !!questionListIndexEdit[index]))
      index === 4 && q.push(question('fifth', index, !!questionListIndexEdit[index]))
    }
    if (counter === 3) {
      questionListData.splice(3)
      questionListData.splice(4)
    }
    if (counter === 4) {
      questionListData.splice(4)
    }
    return q
  }

  const handleAnswerLang = lang => {
    setAnswerLang(lang)
    console.log(answerList)
    const answerData = answerList[lang]
    if (answerData) {
      setAnswer({ ...answerData })
    } else {
      setAnswer({})
    }
    // Reset editor
    setEditorIsVisible(false)
    setTimeout(() => setEditorIsVisible(true))
  }

  const getTypeForLangs = () => {
    const types = {}
    Object.keys(answerList).forEach(lang => types[lang] = answerList[lang].type)
    return types
  }

  return (
    <div className='animated'>
      {!props.editQuestionOpen ? (
        <div id={props.question._id} className='question-container'>
          <div className='switch-container'>
            <Switch
              className='switch'
              onChange={changeStatus}
              checked={isChecked}
              uncheckedIcon={false}
              checkedIcon={false}
              onColor='#E87721'
              onHandleColor='#fff'
            />
            <div className='question-label' alt={props.question.faqTitle}>{props.question.faqTitle}</div>
          </div>
          {shortCut ? <div className='shortcut-text'>{shortCut}</div> : null}

          <div className='buttons-container buttons-container-list'>
            {props.question.reviewStatus !== 'ok' &&
            <>
              <i className='intent-alert' id={`reviewStatus-${props.question._id}`}>
                <img src={`img/icons/${getIcon(props.question.reviewStatus)}`} alt={props.question.reviewStatus}/>
              </i>
              <Tooltip placement='top' isOpen={reviewStatusTooltipOpen} target={`reviewStatus-${props.question._id}`} toggle={toggle}>
                {I18n.t(`faq_console_question_${props.question.reviewStatus}`)}
              </Tooltip>
            </>
            }
            {ALLOWED_DOMAINS.type === 'TA' && !props.question.trained &&
              <Nixi1Spinner height='20px' width='20px' />
            }
            <i className='fa fa-pencil pointer' onClick={openEditQuestion} />
            {
              (ALLOWED_DOMAINS.type !== 'TA' || (ALLOWED_DOMAINS.type === 'TA' && !props.question.trained)) ? (
                <i
                  className='fa fa-trash pointer'
                  onClick={() => setIsOpenModalDelete(!isOpenModalDelete)}
                />
              ) : null
            }
            <i className='fa fa-bars drag-item' {...props.handleDragAndDrop} />
          </div>
        </div>
      ) : (
        <div className='question-add-menu'>
          <div>
            <div className='menu-title'>{I18n.t('dashboard_edit-question')}</div>
          </div>
          {questionList.length < 3 ? (
            <div className='edit-header'>
              <i className='fa fa-exclamation-triangle' aria-hidden='true'></i>
              {I18n.t('faq_console_question_edit_menu_two_questions_banner')}
            </div>
          ) : null}
          <div className='question-add-container'>
            <div className='question-add-section'>
              {showQuestion(counterQuestions.find(it => it.category === props.category).counter)}
              <div className='error-message'>{errorMessage}</div>
              <div className='add-remove-formulation'>
                {counterQuestions.find(it => it.category === props.category).counter < totalQuestions &&
                  ALLOWED_DOMAINS.type !== 'TA' ?
                  <>
                    <i id={`add-formulation-${props.category}`}
                      className='fa fa-plus-circle'
                      onClick={()=>{
                        let _counterQuestions = _.clone(counterQuestions)
                        _counterQuestions.find(it => it.category === props.category).counter += 1
                        setCounterQuestions(_counterQuestions)
                      }}
                    />
                    <UncontrolledTooltip placement='top' target={`add-formulation-${props.category}`}>
                      {I18n.t('dashboard_add-formulation')}
                    </UncontrolledTooltip>
                  </>
                  : !props.editQuestionOpen &&
                    <>
                      <i id={`add-formulation-${props.category}`}
                        className='fa fa-plus-circle'
                        onClick={()=>{
                          let _counterQuestions = _.clone(counterQuestions)
                          _counterQuestions.find(it => it.category === props.category).counter += 1
                          setCounterQuestions(_counterQuestions)
                        }}
                      />
                      <UncontrolledTooltip placement='top' target={`add-formulation-${props.category}`}>
                        {I18n.t('dashboard_add-formulation')}
                      </UncontrolledTooltip>
                    </>
                }
                {counterQuestions.find(it => it.category === props.category).counter > initialQuestions}
                {counterQuestions.find(it => it.category === props.category).counter > initialQuestions &&
                  ALLOWED_DOMAINS.type !== 'TA' ?
                  <>
                    <i id={`remove-formulation-${props.category}`}
                      className='fa fa-minus-circle'
                      onClick={()=>{
                        let _counterQuestions = _.clone(counterQuestions)
                        _counterQuestions.find(it => it.category === props.category).counter -= 1
                        setCounterQuestions(_counterQuestions)
                      }}
                    />
                    <UncontrolledTooltip placement='top' target={`remove-formulation-${props.category}`}>
                      {I18n.t('dashboard_remove-formulation')}
                    </UncontrolledTooltip>
                  </>
                  : !props.editQuestionOpen &&
                  <>
                    <i id={`remove-formulation-${props.category}`}
                      className='fa fa-minus-circle'
                      onClick={()=>{
                        let _counterQuestions = _.clone(counterQuestions)
                        _counterQuestions.find(it => it.category === props.category).counter -= 1
                        setCounterQuestions(_counterQuestions)
                      }}
                    />
                    <UncontrolledTooltip placement='top' target={`remove-formulation-${props.category}`}>
                      {I18n.t('dashboard_remove-formulation')}
                    </UncontrolledTooltip>
                  </>
                }
              </div>
            </div>
            <div className='answer-add-section'>
              <div className='question-input-container question-input-container--answer'>
                <p className='question-input-container__title'>
                  {I18n.t('dashboard_answer')}
                </p>
                {
                  flagEnvDisplay.displayMultiLang
                    ?
                    answerLang ? (
                      <LangSelector
                        allowed={props.translationLanguages}
                        types={getTypeForLangs()}
                        value={answerLang}
                        onChange={({ value }) => handleAnswerLang(value)}
                      />
                    ) : (
                      <Nixi1Spinner width='15px' height='15px' />
                    )
                    : null
                }
              </div>
              {editorIsVisible && (answer?.contentHtml || answer?.content) ? (
                <TextEditor2
                  id={`answer-${props.index}`}
                  cols={5}
                  rows={7}
                  value={answer?.contentHtml || answer?.content || ''}
                  company={props.company}
                  attachments={answer.attachments}
                  buttons={answer.buttons}
                  removeEmojisAndAccentsValue={answer.removeEmojisAndAccents}
                  limit={0}
                  options={["buttons", "emojis", "attachments"]}
                  onChange={(e) => {
                    const preview = {
                      content: e.value,
                      contentHtml: e.valueHtml,
                      buttons: e.buttons,
                      attachments: e.attachments,
                      removeEmojisAndAccents: e.removeEmojisAndAccents
                    }
                    setTextPreview(preview)
                  }}
                  dropZoneFilesHeight={211}
                  currentChannelPreview={currentChannelPreview}
                  cleanSms
                  isTemplateValue
                  minHeight={118}
                  maxHeight={null}
                />
              ) : (
                <Nixi1Spinner width='20px' height='20px' />
              )}
              <div className={'viewer-wrapper'}>
                <span className='text-preview' onClick={() => setOnPreview(!onPreview)}>
                  <li className='fa fa-mobile' />
                  {onPreview ? I18n.t('dashboard_close-preview') : I18n.t('dashboard_open-preview')}
                </span>
                <div className='viewer'>{onPreview && <PhoneViewer textPreview={textPreview} setCurrentChannelPreview={setCurrentChannelPreview} />}</div>
              </div>
            </div>
          </div>
          <div className='footer-container'>
            <div className='buttons-container'>
              <Button
                secondary
                onClick={saveIntent}
                value={I18n.t('dashboard_save')}
                isSubmitting={isSubmitting}
                disabled={disableSaveIntent()}
              />
              <Button
                onClick={closeQuestionEdit}
                value={I18n.t('dashboard_cancel')}
              />
            </div>
            <div className='shortcut-container'>
              <div className='title-container'>
                <div className='title'>{I18n.t('dashboard_shortcut')}</div>
              </div>
              <div className='shortcut'>
                <input
                  id='funcLetterInput'
                  className='letter-input'
                  defaultValue={shortCut ? shortCut : ''}
                  value={funcLetterInput}
                  onChange={({ target: { value } }) => {
                    const validateValue = validateShorcutsAV(value)?.input || ''
                    setFuncLetterInput(validateValue)
                  }}
                />
                <div className='description-container'>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: I18n.t('faq_console_shortcut_description')
                    }}
                    className='description-text'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <ModalDelete
        isOpen={isOpenModalDelete}
        toggle={() => setIsOpenModalDelete(!isOpenModalDelete)}
        header={I18n.t('dashboard_delete-question')}
        text1={I18n.t('dashboard_sure-want-delete-question')}
        text2={I18n.t('dashboard_action-cannot-reversed')}
        event={() => props.deleteQuestion(props.question._id, props.question.category)}
        isSubmitting={props.removing}
      />

    </div>
  )
}

export default ConsoleQuestion
